export const URL_CONSTANTS: any = {
    GET_FAVORITE_PDC: '/api/pdc/v1/favorite',
    CREATE_FAVORITE_PDC: '/api/pdc/v1/favorite/add',
    REMOVE_FAVORITE_PDC: "/api/pdc/v1/favorite/remove",
    GET_CUSTOM_PDC: '/api/pdc/v1/custom',
    CREATE_CUSTOM_PDC: '/api/pdc/v1/custom/create',
    REMOVE_CUSTOM_PDC: "/api/pdc/v1/custom/delete",
    UPDATE_CUSTOM_PDC: "/api/pdc/v1/custom/update",
    CATEGORIES: '/api/pdc/v1/queue'
} 